import {
  ModalDialog,
  ModalDialogContent,
  ModalDialogDescription,
  ModalDialogHeader,
  ModalDialogTitle,
  ModalDialogFooter,
  ModalDialogActions,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import type { ReactNode } from 'react'

/**
 * Props for {@link BusinessProfilesDialog}.
 */
export interface BusinessProfilesDialogProps {
  /**
   * Whether the dialog is open.
   */
  isOpen: boolean

  /**
   * Callback when the dialog should close.
   */
  onClose?: () => void

  /**
   * The children to render (the list of business profiles).
   */
  children?: ReactNode

  /**
   * Test ID attribute.
   */
  testId?: string
  /**
   * Test ID attribute for the close button.
   */
  closeTestId?: string
}

/**
 * Dialog for displaying and selecting business profiles.
 */
export function BusinessProfilesDialog({
  isOpen,
  onClose,
  children,
  testId,
  closeTestId,
}: BusinessProfilesDialogProps) {
  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      sheetSizing="stretch"
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>Your business</ModalDialogTitle>
        <ModalDialogDescription>
          Select a business for this tax return or add a new one.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogContent>{children}</ModalDialogContent>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button
            label="Close"
            variant="outline"
            onPress={onClose}
            testId={closeTestId}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
